import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://crown-cleaners.com';

/**
 * Sets and updates the canonical URL for the current page.
 * Helps Google index the preferred URL and fixes "Duplicate without user-selected canonical"
 * and "Alternate page with proper canonical tag" in Search Console.
 */
function CanonicalTag() {
  const { pathname } = useLocation();

  useEffect(() => {
    const canonical = `${SITE_URL}${pathname === '/' ? '' : pathname}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonical);
    return () => {};
  }, [pathname]);

  return null;
}

export default CanonicalTag;
